import { Input } from 'antd'
import React, { useEffect, useState } from 'react'
import { SketchPicker } from 'react-color';


type IColor = React.PropsWithChildren<{
	value:string;
	colorChange:any;
}>

function InputColor({value, colorChange}:IColor) {
	const [block,setBlock] = useState(false);
	const [color,setColor] = useState(value);

	useEffect(()=>{
		if(value){
			setColor(value)
		}else{
			setColor('#ffffff')
		}
	},[value])

	const onClick = ()=>{
		setBlock(true)
	}
	const onClick2 = ()=>{
		setBlock(false)
	}

	const onChangeColor = (e:any)=>{
		console.log(e)
		setColor(e.hex)
		colorChange(e.hex)
	}
	return (
		<div style={{position:"relative"}}>
			<Input readOnly onClick={onClick} value={color} />
			{
				block?
				<div style={{position:"relative",zIndex:1000}}>
                    <div style={{position:"absolute",zIndex:1}}>
						<SketchPicker color={color} onChange={ (e: any) => onChangeColor(e) } />
                        <div style={{
                                position:"absolute",width:"20px",height:"20px",
                                borderRadius:"100px",border:"1px solid #999999",
                                color:"#000000",top:"-10px",right:"-10px",
                                lineHeight:"20px",fontSize:"14px",textAlign:"center",
                                backgroundColor:"#fff",cursor:"pointer"
                            }}
                            onClick={onClick2}
                        >
                            X
                        </div>
                    </div>
                </div>:null
			}
		</div>
	)
}

export default InputColor